var React = require('react');

function IcoBookSharp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.4667 4C19.227 4.01439 16.8187 4.47649 15.076 5.27511C13.7755 5.87072 13.2667 6.3214 13.2667 7.84816V22.2202C13.2667 22.8541 13.9887 23.2018 14.5036 22.8752C16.1234 21.8477 18.2559 21.5011 23.3018 21.4732C23.6867 21.471 24 21.1421 24 20.736V4.73532C24 4.32922 23.688 4 23.303 4H22.4667ZM2.53333 4C5.77298 4.01439 8.18127 4.47649 9.924 5.27511C11.2245 5.87072 11.7333 6.3214 11.7333 7.84816V22.2202C11.7333 22.8541 11.0113 23.2018 10.4964 22.8752C8.87661 21.8477 6.74414 21.5011 1.69823 21.4732C1.31331 21.471 1 21.1421 1 20.736V4.73532C1 4.32922 1.31204 4 1.69697 4H2.53333Z","fill":"currentColor"}));
}

IcoBookSharp.defaultProps = {"viewBox":"0 0 25 25","fill":"currentColor"};

module.exports = IcoBookSharp;

IcoBookSharp.default = IcoBookSharp;
